export default __webpack_public_path__ + "static/media/a_man_fighting_for_space.15b86682.png";